import React from "react";
import Seo from "../components/Seo";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { RichContent } from "../components/RichText";
import { useContent } from "../context/ContentContext";

export default function InfoPage({ kind }) {
  const { p } = useContent();
  const c = p(kind).main;
  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14 min-h-[60vh]" data-testid={`info-${kind}`}>
      <Seo title={`${c.title} — CaminoSapiens`} description={c.title} />
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: c.title }]} />
      <h1 className="font-display text-4xl sm:text-5xl">{c.title}</h1>
      <RichContent html={c.body} className="mt-8" />
    </div>
  );
}
